var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 4.5,
  width: 12,
  height: 13,
  rx: 1.5,
  stroke: "currentColor"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8849 0.682504C16.2885 0.305567 16.9213 0.327227 17.2983 0.730882L18.6633 2.19265C19.0402 2.5963 19.0185 3.2291 18.6149 3.60603L17.884 4.28854L15.154 1.36501L15.8849 0.682504ZM14.4231 2.04751L17.1531 4.97104L9.11342 12.4786L6.3834 9.55505L14.4231 2.04751ZM5.82506 10.0764L5.65252 10.2376L5.67181 10.2582C5.63066 10.3208 5.59654 10.3881 5.57025 10.4588L4.3031 13.8669C4.21694 14.0987 4.4323 14.3293 4.66937 14.2592L8.15616 13.228C8.2285 13.2066 8.29795 13.1772 8.36324 13.1404L8.38253 13.1611L8.55507 13C8.49675 13.0544 8.43231 13.1015 8.36324 13.1404L5.67181 10.2582C5.71534 10.192 5.76673 10.1309 5.82506 10.0764Z",
  fill: "currentColor"
})));
export default SvgEdit;